<app-spinner [isLoading]="isLoading$ | async">
  <div
    class="container"
    *ngIf="{
      isJobseekerPasswordChangeRequired:
        isJobseekerPasswordChangeRequired$ | async,
      isJobseekerEmailChangeRequested: isJobseekerEmailChangeRequested$ | async
    } as data"
  >
    <p-tabs
      class="edit-view"
      scrollable
      [value]="data.isJobseekerEmailChangeRequested || data.isJobseekerPasswordChangeRequired ? 0 : 1"
    >
      <p-tablist>
        <p-tab [value]="0" class="tab-header">
          {{ 'label.UserPassword' | translate }}
        </p-tab>

        <p-tab [value]="1" class="tab-header">
          {{ 'label.Privacy' | translate }}
        </p-tab>

        <p-tab [value]="2" class="tab-header">
          {{ 'label.BlackList' | translate }}
        </p-tab>
      </p-tablist>

      <p-tabpanels>
        <p-tabpanel [value]="0">
          <div class="tab">
            <app-jobseeker-settings-change-email></app-jobseeker-settings-change-email>
            <app-jobseeker-settings-change-password></app-jobseeker-settings-change-password>
          </div>
        </p-tabpanel>

        <!-- Privacy -->
        <p-tabpanel [value]="1">
          <div class="tab">
            <app-spinner
              [isLoading]="isUpdating$ | async"
              [isFixedPosition]="false"
            >
              <app-jobseeker-settings-privacy></app-jobseeker-settings-privacy>
            </app-spinner>
          </div>
        </p-tabpanel>

        <!-- BlackList -->
        <p-tabpanel [value]="2">
          <div class="tab">
            <app-spinner
              [isLoading]="isUpdating$ | async"
              [isFixedPosition]="false"
            >
              <app-jobseeker-settings-blacklist></app-jobseeker-settings-blacklist>
            </app-spinner>
          </div>
        </p-tabpanel>
      </p-tabpanels>
    </p-tabs>
  </div>
</app-spinner>
